import React from 'react';
export function EntrepriseForm() {
  return <div className="bg-white p-4 md:p-6 rounded-3xl shadow-xl border border-slate-100" data-id="element-343" data-mp="hxbuoq10l8yz">
      <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSeCS6XG0ikZm8CIUcshU0XRu-6S-gXo9S-7XP4hz0Hp1RSaCA/viewform?embedded=true" width="100%" height="2748" frameBorder={0} marginHeight={0} marginWidth={0} title="Formulaire entreprise — Zillenium Alternance" className="w-full rounded-2xl" data-id="element-344" data-mp="3oy7m4lqzewoh">
        Chargement…
      </iframe>
    </div>;
}